import Page from "webPage/Page";

Page.register("page-template-contact", () => {
    $("body").on('change blur focus', 'input, textarea, select', function () {
        console.log($(this).val().trim());

        if ($(this).val().trim() === '') {
            $(this).closest('.gfield').removeClass('gfield--active');
        } else {
            $(this).closest('.gfield').addClass('gfield--active');
        }
    })
});